import React, { useState } from "react";

const Field = ({ label, children, required, colSpan }) => (
  <div className={colSpan ? "col-span-2" : ""}>
    <label className="label-cap block mb-1.5">{label}{required && <span className="text-[#DC2626]">*</span>}</label>
    {children}
  </div>
);

// Isolated modal form — punya state sendiri sehingga keystroke TIDAK trigger re-render
// daftar 4000+ pelanggan di parent. Form di-submit ke parent via onSubmit(values).
const CustomerFormModal = ({ initial, editingId, onClose, onSubmit, saving = false, hint = null }) => {
  const [form, setForm] = useState(initial);
  const handleSubmit = (e) => { e.preventDefault(); onSubmit(form); };
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50" onClick={onClose}>
      <form onClick={(e) => e.stopPropagation()} onSubmit={handleSubmit} className="bg-white border border-[#E4E4E7] w-full max-w-2xl" data-testid="customer-form">
        <div className="px-6 py-4 border-b border-[#E4E4E7]">
          <div className="label-cap">{editingId ? "Ubah" : "Tambah"} Data</div>
          <h2 className="font-heading text-2xl font-bold">Pelanggan</h2>
        </div>
        {hint && <div className="px-6 pt-4 text-xs text-[#52525B]">{hint}</div>}
        <div className="p-6 grid grid-cols-2 gap-4 max-h-[65vh] overflow-y-auto">
          <Field label="Nama" required>
            <input data-testid="customer-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className="w-full px-3 py-2 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7]" />
          </Field>
          <Field label="Telepon" required>
            <input data-testid="customer-phone-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} required placeholder="08xxxxxxxxxx" className="w-full px-3 py-2 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7] font-mono" />
          </Field>
          <Field label="Alamat" colSpan>
            <textarea data-testid="customer-address-input" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} rows={2} className="w-full px-3 py-2 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7]" />
          </Field>
          <Field label="Kota" colSpan>
            <input data-testid="customer-city-input" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} placeholder="Bekasi / Jakarta / dst" className="w-full px-3 py-2 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7]" />
          </Field>
          <Field label="Link Google Maps" colSpan>
            <input data-testid="customer-maps-input" value={form.maps_link} onChange={(e) => setForm({ ...form, maps_link: e.target.value })} placeholder="https://maps.google.com/..." className="w-full px-3 py-2 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7]" />
          </Field>
          <Field label="Latitude">
            <input data-testid="customer-lat-input" value={form.latitude} onChange={(e) => setForm({ ...form, latitude: e.target.value })} placeholder="-6.2088" className="w-full px-3 py-2 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7] font-mono" />
          </Field>
          <Field label="Longitude">
            <input data-testid="customer-lng-input" value={form.longitude} onChange={(e) => setForm({ ...form, longitude: e.target.value })} placeholder="106.8456" className="w-full px-3 py-2 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7] font-mono" />
          </Field>
          <Field label="Catatan" colSpan>
            <textarea data-testid="customer-notes-input" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} rows={2} className="w-full px-3 py-2 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7]" />
          </Field>
        </div>
        <div className="px-6 py-4 border-t border-[#E4E4E7] flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 text-xs font-bold uppercase tracking-wider border border-[#E4E4E7]">Batal</button>
          <button type="submit" disabled={saving} data-testid="customer-submit-button" className="disabled:opacity-60 px-4 py-2 text-xs font-bold uppercase tracking-wider bg-[#002FA7] text-white hover:bg-[#00227A]">{saving ? "Menyimpan…" : "Simpan"}</button>
        </div>
      </form>
    </div>
  );
};

export const customerToForm = (c) => ({
  name: c.name || "", phone: c.phone || "", address: c.address || "", city: c.city || "",
  maps_link: c.maps_link || "",
  latitude: c.latitude ?? "", longitude: c.longitude ?? "",
  notes: c.notes || "",
});

export const formToCustomerPayload = (form) => ({
  ...form,
  latitude: form.latitude === "" || form.latitude === null ? null : Number(form.latitude),
  longitude: form.longitude === "" || form.longitude === null ? null : Number(form.longitude),
});

export default CustomerFormModal;
